
(function initThemeVars() {
  if (!window.themeVariables) window.themeVariables = { settings: {} };
  if (!window.themeVariables.settings) window.themeVariables.settings = {};
  if (!window.themeVariables.settings.direction)
    window.themeVariables.settings.direction = document.documentElement.getAttribute('dir') || 'ltr';
})();

function createFocusTrap(_root, opts = {}) {
  return {
    activate() { if (opts.initialFocus) try { const el = typeof opts.initialFocus === 'string' ? document.querySelector(opts.initialFocus) : opts.initialFocus; el && el.focus && el.focus(); } catch(_){} },
    deactivate() { if (opts.onDeactivate) opts.onDeactivate(); }
  };
}

function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: data }));
}
function triggerNonBubblingEvent(element, name, data = {}) {
  element.dispatchEvent(new CustomEvent(name, { bubbles: false, detail: data }));
}

function throttle(callback, delay = 15) {
  let throttleTimeout = null, storedEvent = null;
  const throttledEventHandler = (event) => {
    storedEvent = event;
    if (!throttleTimeout) {
      callback(storedEvent);
      storedEvent = null;
      throttleTimeout = setTimeout(() => {
        throttleTimeout = null;
        if (storedEvent) throttledEventHandler(storedEvent);
      }, delay);
    }
  };
  return throttledEventHandler;
}

function matchesTag(tagName, element) { return tagName.toLowerCase() === element.tagName.toLowerCase(); }
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return element === document || element === document.documentElement || element === window;
  }
  return this.rootElement === element;
}
function matchesId(id, element) { return id === element.id; }

function Delegate(root) {
  this.listenerMap = [{}, {}];
  if (root) this.root(root);
  this.handle = this.handle.bind(this);
  this._removedListeners = [];
}
Delegate.prototype.root = function(root) {
  const listenerMap = this.listenerMap;
  let eventType;
  if (this.rootElement) {
    for (eventType in listenerMap[1]) if (listenerMap[1].hasOwnProperty(eventType))
      this.rootElement.removeEventListener(eventType, this.handle, true);
    for (eventType in listenerMap[0]) if (listenerMap[0].hasOwnProperty(eventType))
      this.rootElement.removeEventListener(eventType, this.handle, false);
  }
  if (!root || !root.addEventListener) { if (this.rootElement) delete this.rootElement; return this; }
  this.rootElement = root;
  for (eventType in listenerMap[1]) if (listenerMap[1].hasOwnProperty(eventType))
    this.rootElement.addEventListener(eventType, this.handle, true);
  for (eventType in listenerMap[0]) if (listenerMap[0].hasOwnProperty(eventType))
    this.rootElement.addEventListener(eventType, this.handle, false);
  return this;
};
Delegate.prototype.captureForType = function(eventType) {
  return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
};
Delegate.prototype.on = function(eventType, selector, handler, useCapture) {
  let matcher, matcherParam;
  if (!eventType) throw new TypeError("Invalid event type: " + eventType);
  if (typeof selector === "function") { useCapture = handler; handler = selector; selector = null; }
  if (useCapture === void 0) useCapture = this.captureForType(eventType);
  if (typeof handler !== "function") throw new TypeError("Handler must be a type of Function");
  const root = this.rootElement, listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!listenerMap[eventType]) {
    if (root) root.addEventListener(eventType, this.handle, useCapture);
    listenerMap[eventType] = [];
  }
  if (!selector) { matcherParam = null; matcher = matchesRoot.bind(this); }
  else if (/^[a-z]+$/i.test(selector)) { matcherParam = selector; matcher = matchesTag; }
  else if (/^#[a-z0-9\-_]+$/i.test(selector)) { matcherParam = selector.slice(1); matcher = matchesId; }
  else { matcherParam = selector; matcher = Element.prototype.matches; }
  listenerMap[eventType].push({ selector, handler, matcher, matcherParam });
  return this;
};
Delegate.prototype.off = function(eventType, selector, handler, useCapture) {
  let listenerList;
  if (typeof selector === "function") { useCapture = handler; handler = selector; selector = null; }
  if (useCapture === void 0) { this.off(eventType, selector, handler, true); this.off(eventType, selector, handler, false); return this; }
  const listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (const singleEventType in listenerMap) if (listenerMap.hasOwnProperty(singleEventType))
      this.off(singleEventType, selector, handler, useCapture);
    return this;
  }
  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) return this;
  for (let i = listenerList.length - 1; i >= 0; i--) {
    const listener = listenerList[i];
    if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }
  if (!listenerList.length) {
    delete listenerMap[eventType];
    if (this.rootElement) this.rootElement.removeEventListener(eventType, this.handle, useCapture);
  }
  return this;
};
Delegate.prototype.handle = function(event) {
  const type = event.type;
  let listenerList = [];
  const phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
  if (phase === 1) listenerList = this.listenerMap[1][type] || [];
  if (phase === 2) {
    if (this.listenerMap[0][type]) listenerList = listenerList.concat(this.listenerMap[0][type]);
    if (this.listenerMap[1][type]) listenerList = listenerList.concat(this.listenerMap[1][type]);
  }
  if (phase === 3) listenerList = this.listenerMap[0][type] || [];

  const eventIgnore = "ftLabsDelegateIgnore";
  if (event[eventIgnore] === true) return;

  let target = event.target;
  if (target && target.nodeType === 3) target = target.parentNode;
  if (target && target.correspondingUseElement) target = target.correspondingUseElement;

  let toFire = [], l = listenerList.length, root = this.rootElement;
  while (target && l) {
    for (let i = 0; i < l; i++) {
      const listener = listenerList[i];
      if (!listener) break;
      if (target.tagName && ["button","input","select","textarea"].includes(target.tagName.toLowerCase()) && target.hasAttribute("disabled")) {
        toFire = [];
      } else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }
    if (target === root) break;
    l = listenerList.length;
    target = target.parentElement || target.parentNode;
    if (target instanceof HTMLDocument) break;
  }

  for (let i = 0; i < toFire.length; i++) {
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) continue;
    const returned = this.fire.apply(this, toFire[i]);
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      return false;
    }
  }
};
Delegate.prototype.fire = function(event, target, listener) {
  return listener.handler.call(target, event, target);
};
Delegate.prototype.destroy = function() { this.off(); this.root(); };

function filterShopifyEvent(event, element, callback) {
  try {
    const parentSection = element.closest('.shopify-section');
    const matchesSection = event && parentSection && event.target === parentSection;
    const shouldRun = !event || !event.detail || event.detail.load;
    if (matchesSection && shouldRun) callback();
  } catch(_) {}
}

class CustomHTMLElement extends HTMLElement {
  get rootDelegate() { return this._rootDelegate = this._rootDelegate || new Delegate(document.documentElement); }
  get delegate() { return this._delegate = this._delegate || new Delegate(this); }
  showLoadingBar() { triggerEvent(document.documentElement, "theme:loading:start"); }
  hideLoadingBar() { triggerEvent(document.documentElement, "theme:loading:end"); }
  untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
    const onBecameVisible = () => { this.classList.add("became-visible"); this.style.opacity = "1"; };
    return new Promise((resolve) => {
      if (window.IntersectionObserver) {
        this.intersectionObserver = new IntersectionObserver((e) => {
          if (e[0].isIntersecting) {
            this.intersectionObserver.disconnect();
            requestAnimationFrame(() => { resolve(); onBecameVisible(); });
          }
        }, intersectionObserverOptions);
        this.intersectionObserver.observe(this);
      } else { resolve(); onBecameVisible(); }
    });
  }
  disconnectedCallback() {
    if (this.delegate) this.delegate.destroy();
    if (this.rootDelegate) this.rootDelegate.destroy();
    if (this.intersectionObserver) this.intersectionObserver.disconnect();
    delete this._delegate; delete this._rootDelegate;
  }
}

class OpenableElement extends CustomHTMLElement {
  static get observedAttributes() { return ["open"]; }
  constructor() {
    super();
    if (window.Shopify && Shopify.designMode) {
      this.rootDelegate.on("shopify:section:select", (e) => filterShopifyEvent(e, this, () => this.open = true));
      this.rootDelegate.on("shopify:section:deselect", (e) => filterShopifyEvent(e, this, () => this.open = false));
    }
    if (this.hasAttribute("append-body")) {
      const existingNode = document.getElementById(this.id);
      this.removeAttribute("append-body");
      if (existingNode && existingNode !== this) {
        existingNode.replaceWith(this.cloneNode(true));
        this.remove();
      } else {
        document.body.appendChild(this);
      }
    }
  }
  connectedCallback() {
    this.delegate.on("click", ".openable__overlay", () => this.open = false);
    this.delegate.on("click", '[data-action="close"]', (event) => { event.stopPropagation(); this.open = false; });
  }
  get requiresLoading() { return this.hasAttribute("href"); }
  get open() { return this.hasAttribute("open"); }
  set open(value) {
    if (value) {
      (async () => { await this._load(); this.clientWidth; this.setAttribute("open",""); })();
    } else {
      this.removeAttribute("open");
    }
  }
  get shouldTrapFocus() { return true; }
  get returnFocusOnDeactivate() {
    return !this.hasAttribute("return-focus") || this.getAttribute("return-focus") === "true";
  }
  get focusTrap() {
    return this._focusTrap = this._focusTrap || createFocusTrap(this, {
      fallbackFocus: this,
      initialFocus: this.getAttribute("initial-focus-selector") || undefined,
      clickOutsideDeactivates: (event) => !(event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id),
      allowOutsideClick: (event) => event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id,
      returnFocusOnDeactivate: this.returnFocusOnDeactivate,
      onDeactivate: () => this.open = false,
      preventScroll: true
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open") {
      if (oldValue === null && newValue === "") { if (this.shouldTrapFocus) setTimeout(() => this.focusTrap.activate(), 150); triggerEvent(this, "openable-element:open"); }
      else if (newValue === null) { if (this.shouldTrapFocus) this.focusTrap.deactivate(); triggerEvent(this, "openable-element:close"); }
    }
  }
  async _load() {
    if (!this.requiresLoading) return;
    triggerNonBubblingEvent(this, "openable-element:load:start");
    const response = await fetch(this.getAttribute("href"));
    const wrapper = document.createElement("div");
    wrapper.innerHTML = await response.text();
    const replacement = wrapper.querySelector(this.tagName.toLowerCase());
    if (replacement) this.innerHTML = replacement.innerHTML;
    this.removeAttribute("href");
    triggerNonBubblingEvent(this, "openable-element:load:end");
  }
}
window.customElements.define("openable-element", OpenableElement);

class CollapsibleContent extends OpenableElement {
  constructor() {
    super();
    this.ignoreNextTransition = this.open;
    this.addEventListener("shopify:block:select", () => this.open = true);
    this.addEventListener("shopify:block:deselect", () => this.open = false);
  }
  get animateItems() { return this.hasAttribute("animate-items"); }
  attributeChangedCallback(name) {
    if (this.ignoreNextTransition) { this.ignoreNextTransition = false; return; }
    if (name === "open") {
      this.style.overflow = "hidden";
      const keyframes = {
        height: ["0px", `${this.scrollHeight}px`],
        visibility: ["hidden", "visible"]
      };
      if (this.animateItems) keyframes.opacity = this.open ? [0, 0] : [0, 1];
      this.animate(keyframes, {
        duration: 500,
        direction: this.open ? "normal" : "reverse",
        easing: "cubic-bezier(0.75, 0, 0.175, 1)"
      }).onfinish = () => { this.style.overflow = this.open ? "visible" : "hidden"; };
      if (this.animateItems && this.open) {
        this.animate({ opacity:[0,1], transform:["translateY(10px)","translateY(0)"] }, { duration:250, delay:250, easing:"cubic-bezier(0.75, 0, 0.175, 1)" });
      }
      triggerEvent(this, this.open ? "openable-element:open" : "openable-element:close");
    }
  }
}
window.customElements.define("collapsible-content", CollapsibleContent);


class TabsNav extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"));
    if (!this.buttons.length) return;

    this.scrollerElement = this.querySelector(".tabs-nav__scroller");
    this.buttons.forEach((button) => button.addEventListener("click", () => this.selectButton(button)));

    this.addEventListener("shopify:block:select", (event) => this.selectButton(event.target, !(event.detail && event.detail.load)));

    this.positionElement = document.createElement("span");
    this.positionElement.classList.add("tabs-nav__position");
    this.buttons[0].parentElement.insertAdjacentElement("afterend", this.positionElement);

    if (this.hasArrows) this._handleArrows();

    window.addEventListener("resize", this._onWindowResized.bind(this));
    this._adjustNavigationPosition();
  }
  get hasArrows() { return this.hasAttribute("arrows"); }
  get selectedTabIndex() { return this.buttons.findIndex((b) => b.getAttribute("aria-expanded") === "true"); }
  get selectedButton() { return this.buttons.find((b) => b.getAttribute("aria-expanded") === "true") || this.buttons[0]; }

  selectButton(button, animate = true) {
    if (!this.buttons.includes(button) || this.selectedButton === button) return;

    const from = document.getElementById(this.selectedButton.getAttribute("aria-controls"));
    const to   = document.getElementById(button.getAttribute("aria-controls"));

    if (from && to) {
      if (animate && from.animate) {
        this._transitionContent(from, to);
      } else {
        from.hidden = true;
        to.hidden = false;
      }
    }

    this.selectedButton.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-expanded", "true");

    triggerEvent(this, "tabs-nav:changed", { button });
    this._adjustNavigationPosition();
  }

  _transitionContent(from, to) {
    from.animate({ opacity:[1,0] }, { duration:250, easing:"ease" }).onfinish = () => {
      from.hidden = true; to.hidden = false;
      to.animate({ opacity:[0,1] }, { duration:250, easing:"ease" });
    };
  }

  _onWindowResized() { this._adjustNavigationPosition(); }

  _adjustNavigationPosition(shouldAnimate = true) {
    if (!this.selectedButton || !this.positionElement) return;

    const parentWidth = this.positionElement.parentElement.clientWidth || 1;
    const scale = this.selectedButton.clientWidth / parentWidth;
    const translate = (this.selectedButton.offsetLeft / parentWidth) / (scale || 1);
    const windowHalfWidth = (this.scrollerElement ? this.scrollerElement.clientWidth : 0) / 2;

    if (this.scrollerElement && this.scrollerElement.scrollTo) {
      this.scrollerElement.scrollTo({
        behavior: shouldAnimate ? "smooth" : "auto",
        left: this.selectedButton.offsetLeft - windowHalfWidth + this.selectedButton.clientWidth / 2
      });
    }
    if (!shouldAnimate) this.positionElement.style.transition = "none";

    this.positionElement.style.setProperty("--scale", scale);
    this.positionElement.style.setProperty("--translate", `${translate * 100}%`);
    void this.positionElement.clientWidth;
    requestAnimationFrame(() => {
      this.positionElement.classList.add("is-initialized");
      this.positionElement.style.transition = null;
    });
  }

  _handleArrows() {
    const arrowsContainer = this.querySelector(".tabs-nav__arrows");
    if (!arrowsContainer) return;
    const prevBtn = arrowsContainer.firstElementChild;
    const nextBtn = arrowsContainer.lastElementChild;
    prevBtn && prevBtn.addEventListener("click", () => {
      this.selectButton(this.buttons[Math.max(this.selectedTabIndex - 1, 0)]);
    });
    nextBtn && nextBtn.addEventListener("click", () => {
      this.selectButton(this.buttons[Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)]);
    });
  }
}
window.customElements.define("tabs-nav", TabsNav);

class ScrollableContent extends CustomHTMLElement {
  connectedCallback() {
    this._checkScrollability();
    window.addEventListener("resize", this._checkScrollability.bind(this));
    this.addEventListener("scroll", throttle(this._calculateProgress.bind(this), 15));
  }
  _checkScrollability() { this.classList.toggle("is-scrollable", this.scrollWidth > this.offsetWidth); }
  _calculateProgress() {
    const dir = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.direction) || 'ltr';
    const scrollLeft = this.scrollLeft * (dir === "ltr" ? 1 : -1);
    const progress = Math.max(0, Math.min(1, scrollLeft / (this.scrollWidth - this.clientWidth))) * 100;
    triggerEvent(this, "scrollable-content:progress", { progress });
  }
}
window.customElements.define("scrollable-content", ScrollableContent);


class ToggleButton extends HTMLButtonElement {
  connectedCallback() {
    if (this._bound) return;
    this.addEventListener("click", this._onClick.bind(this));
    this._bound = true;
  }
  _onClick(e) {
    const targetId = this.getAttribute("aria-controls");
    if (!targetId) return;
    const target = document.getElementById(targetId);
    if (!target) return;

    const expanded = this.getAttribute("aria-expanded") === "true";
    const next = !expanded;
    this.setAttribute("aria-expanded", String(next));

    if ("open" in target) {
      if (next) target.setAttribute("open", "");
      else target.removeAttribute("open");
    } else {
      target.hidden = !next ? true : false;
    }
  }
}

try { window.customElements.define("toggle-button", ToggleButton, { extends: "button" }); }
catch(_) { /* browsers without customized built-ins will use the fallback delegate */ }

document.addEventListener("click", (e) => {
  const btn = e.target.closest('button[is="toggle-button"]');
  if (!btn) return;
  // if the custom element upgraded, its handler already ran
  if (btn instanceof ToggleButton) return;
  const targetId = btn.getAttribute("aria-controls");
  if (!targetId) return;
  const target = document.getElementById(targetId);
  if (!target) return;

  const expanded = btn.getAttribute("aria-expanded") === "true";
  const next = !expanded;
  btn.setAttribute("aria-expanded", String(next));
  if ("open" in target) {
    if (next) target.setAttribute("open", "");
    else target.removeAttribute("open");
  } else {
    target.hidden = !next ? true : false;
  }
}, true);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".rte iframe").forEach((iframe) => {
    if (
      iframe.src.includes("youtube") ||
      iframe.src.includes("youtu.be") ||
      iframe.src.includes("vimeo")
    ) {
      const wrapper = document.createElement("div");
      wrapper.className = "video-wrapper";
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    }
  });
});
